import Cookie from 'js-cookie'
import store from '@/store'
import {tokenTimeLeft} from '@/session/session'

export default async function isLogged ({ next }) {
  const token = Cookie.get('sofom_tkn')
  const tokenExpTime = Cookie.get('sofom_tkn_exp')
  const email = Cookie.get('sofom_email')
  if (!store.getters.sessionIsAlive) {
    if (sessionStorage.getItem('sofom_sameSite') === 'false' ||
      !sessionStorage.getItem('sofom_sameSite')) {
      token && sessionStorage.setItem('sofom_sameSite', true)
      if (token && tokenExpTime) {
        const timeLeft = tokenTimeLeft(tokenExpTime)
        timeLeft > 0.5
          ? await store.dispatch('middlewareLogin', token)
          : store.dispatch('signout')
      }
    }
  } else {
    await store.dispatch('refreshToken')
  }
  email && store.dispatch('middlewareGetEmail', email)
  return next()
}



// WEBPACK FOOTER //
// ./src/middleware/isLogged.js